/* PRECIOUS PLUGS — Product page: gallery, variants, quantity, sticky bar, lightbox */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function parseJSON(el, fallback) {
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  function PPProduct(root) {
    this.root = root;
    this.gallery = root.querySelector('[data-pp-gallery]');
    this.track = root.querySelector('[data-pp-gallery-track]');
    this.slides = this.track ? Array.prototype.slice.call(this.track.children) : [];
    this.thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pp-thumb]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-pp-dot]'));
    this.current = root.querySelector('[data-pp-gallery-current]');
    this.prevBtn = root.querySelector('[data-pp-gallery-prev]');
    this.nextBtn = root.querySelector('[data-pp-gallery-next]');
    this.variants = parseJSON(root.querySelector('[data-pp-variants]'), []);
    this.strings = parseJSON(root.querySelector('[data-pp-strings]'), { addToCart: 'In den Warenkorb', soldOut: 'Ausverkauft', unavailable: 'Nicht verfügbar' });
    this.picker = root.querySelector('[data-pp-variant-picker]');
    this.idInput = root.querySelector('[data-pp-variant-id]');
    this.index = 0;
    this.initGallery();
    this.initVariants();
    this.initQuantity();
    this.initSticky();
    this.initLightbox();
  }

  /* ---------- Gallery ---------- */
  PPProduct.prototype.initGallery = function () {
    var self = this;
    if (!this.track || this.slides.length < 2) return;
    var raf = null;
    this.track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var w = self.track.clientWidth || 1;
        var i = Math.round(self.track.scrollLeft / w);
        if (i !== self.index) self.setActive(i);
      });
    }, { passive: true });
    this.thumbs.forEach(function (t) {
      t.addEventListener('click', function () { self.goTo(parseInt(t.getAttribute('data-pp-thumb'), 10)); });
    });
    if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.goTo(self.index - 1); });
    if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.goTo(self.index + 1); });
    this.track.setAttribute('tabindex', '0');
    this.track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(self.index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(self.index - 1); }
    });
    this.setActive(0);
  };

  PPProduct.prototype.setActive = function (i) {
    i = Math.max(0, Math.min(this.slides.length - 1, i));
    this.index = i;
    this.thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); t.setAttribute('aria-selected', ti === i ? 'true' : 'false'); });
    this.dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
    if (this.current) this.current.textContent = i + 1;
    if (this.prevBtn) this.prevBtn.disabled = i === 0;
    if (this.nextBtn) this.nextBtn.disabled = i === this.slides.length - 1;
    var activeThumb = this.thumbs[i];
    if (activeThumb && activeThumb.parentElement) {
      var p = activeThumb.parentElement;
      var left = activeThumb.offsetLeft - p.clientWidth / 2 + activeThumb.clientWidth / 2;
      p.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  };

  PPProduct.prototype.goTo = function (i, instant) {
    if (!this.track || !this.slides.length) return;
    i = Math.max(0, Math.min(this.slides.length - 1, i));
    this.track.scrollTo({ left: this.slides[i].offsetLeft - this.track.offsetLeft, behavior: (instant || reduceMotion) ? 'auto' : 'smooth' });
    this.setActive(i);
  };

  PPProduct.prototype.goToMedia = function (mediaId) {
    if (!mediaId) return;
    for (var i = 0; i < this.slides.length; i++) {
      if (String(this.slides[i].getAttribute('data-media-id')) === String(mediaId)) { this.goTo(i); return; }
    }
  };

  /* ---------- Variants ---------- */
  PPProduct.prototype.initVariants = function () {
    var self = this;
    if (!this.picker) return;
    this.picker.addEventListener('change', function () { self.onVariantChange(); });
    this.updateAvailability();
  };

  PPProduct.prototype.getSelected = function () {
    var groups = this.picker.querySelectorAll('[data-pp-option-index]');
    var values = [];
    groups.forEach(function (g) {
      var checked = g.querySelector('input:checked');
      values.push(checked ? checked.value : null);
      var cur = g.querySelector('[data-pp-option-current]');
      if (cur && checked) cur.textContent = checked.value;
    });
    return values;
  };

  PPProduct.prototype.findVariant = function (values) {
    for (var i = 0; i < this.variants.length; i++) {
      var v = this.variants[i];
      var match = true;
      for (var j = 0; j < values.length; j++) {
        if (v.options[j] !== values[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  };

  PPProduct.prototype.updateAvailability = function () {
    var self = this;
    var selected = this.getSelected();
    var groups = this.picker.querySelectorAll('[data-pp-option-index]');
    groups.forEach(function (g, gi) {
      g.querySelectorAll('input').forEach(function (input) {
        var test = selected.slice();
        test[gi] = input.value;
        var available = self.variants.some(function (v) {
          if (!v.available) return false;
          for (var k = 0; k < test.length; k++) {
            if (k === gi) { if (v.options[k] !== test[k]) return false; }
            else if (k < gi && v.options[k] !== test[k]) return false;
          }
          return true;
        });
        input.classList.toggle('is-unavailable', !available);
      });
    });
  };

  PPProduct.prototype.onVariantChange = function () {
    var values = this.getSelected();
    var variant = this.findVariant(values);
    this.updateAvailability();
    var atcButtons = this.root.querySelectorAll('[data-pp-atc], [data-pp-atc-sticky]');
    var texts = this.root.querySelectorAll('[data-pp-atc-text]');
    var self = this;

    if (!variant) {
      atcButtons.forEach(function (b) { b.setAttribute('disabled', 'disabled'); });
      texts.forEach(function (t) { t.textContent = self.strings.unavailable; });
      return;
    }

    if (this.idInput) {
      this.idInput.value = variant.id;
      this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    this.root.querySelectorAll('[data-pp-price]').forEach(function (el) { el.textContent = variant.price; });
    this.root.querySelectorAll('[data-pp-compare]').forEach(function (el) {
      if (variant.compare) { el.textContent = variant.compare; el.hidden = false; }
      else { el.textContent = ''; el.hidden = true; }
    });

    atcButtons.forEach(function (b) {
      if (variant.available) { b.removeAttribute('disabled'); b.removeAttribute('aria-disabled'); }
      else b.setAttribute('disabled', 'disabled');
    });
    texts.forEach(function (t) { t.textContent = variant.available ? self.strings.addToCart : self.strings.soldOut; });

    if (variant.media) this.goToMedia(variant.media);

    if (this.root.getAttribute('data-update-url') === 'true' && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    // Keep Shopify dynamic checkout buttons in sync
    var form = this.idInput ? this.idInput.form : null;
    if (form) form.dispatchEvent(new Event('change', { bubbles: true }));

    if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      try {
        window.publish(window.PUB_SUB_EVENTS.variantChange, { data: { sectionId: this.root.getAttribute('data-section-id'), variant: variant } });
      } catch (e) { /* noop */ }
    }
  };

  /* ---------- Quantity ---------- */
  PPProduct.prototype.initQuantity = function () {
    this.root.querySelectorAll('[data-pp-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('input');
        if (!input) return;
        var step = parseInt(btn.getAttribute('data-pp-qty'), 10) || 0;
        var min = parseInt(input.min, 10) || 1;
        var max = input.max ? parseInt(input.max, 10) : Infinity;
        var val = (parseInt(input.value, 10) || min) + step;
        input.value = Math.max(min, Math.min(max, val));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  };

  /* ---------- Sticky add-to-cart ---------- */
  PPProduct.prototype.initSticky = function () {
    var bar = this.root.querySelector('[data-pp-sticky]');
    var buy = this.root.querySelector('[data-pp-buy]');
    if (!bar || !buy) return;
    var footer = document.querySelector('.pp-footer') || document.querySelector('footer');
    var shown = null;
    var ticking = false;
    var update = function () {
      ticking = false;
      var vh = window.innerHeight || 800;
      var pastBuy = buy.getBoundingClientRect().bottom < 0;
      var footerVisible = footer ? footer.getBoundingClientRect().top < vh : false;
      var show = pastBuy && !footerVisible;
      if (show === shown) return;
      shown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('button').forEach(function (b) { b.tabIndex = show ? 0 : -1; });
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  /* ---------- Lightbox ---------- */
  PPProduct.prototype.initLightbox = function () {
    var dialog = this.root.querySelector('[data-pp-lightbox]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var img = dialog.querySelector('[data-pp-lightbox-img]');
    var close = function () { dialog.close(); };
    this.root.querySelectorAll('[data-pp-zoom]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        img.src = btn.getAttribute('data-pp-zoom');
        var inner = btn.querySelector('img');
        img.alt = inner ? inner.alt : '';
        dialog.showModal();
      });
    });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || e.target === img) close();
    });
    var closeBtn = dialog.querySelector('[data-pp-lightbox-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-pp-product]').forEach(function (root) {
      if (root.ppProduct) return;
      root.ppProduct = new PPProduct(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
